module.exports = __webpack_public_path__ + "static/img/santander.315be0de.svg";